module.exports = require('./helpers/bundle-url').getBundleURL('jI9C4') + "logo.c51670a8.svg";